import { createContext, useContext } from 'react';
export const UpdateProductActionContext = /*#__PURE__*/createContext(undefined);
export const useUpdateProductAction = () => {
  const context = useContext(UpdateProductActionContext);
  if (context === undefined) {
    throw new Error('UpdateProductActionContext data is undefined. useUpdateProductAction must be used within a UpdateProductActionContext.Provider');
  }
  return context;
};